import React, { Component } from 'react'
import { Form, Checkbox, Grid, Header, Image, Icon} from 'semantic-ui-react'
import { connect } from 'react-redux'
import AddressForm from './addressForm'
import { DropDown } from '../formComponents/dropDown'
import CustomCheckBox from '../formComponents/checkBox'
import InputField from '../formComponents/inputField'
import * as actionCreators from '../actions'
import { saveSameAs } from '../api/setFormData'
import { saveImporterField, saveNewManufacturer, removeAManufacturer, callAutosuggestAPI, saveBondInfo } from '../api/setFormData'
import PscHeaderReason from "./headerReason";
import { get } from 'lodash'
import {fetchSelectedReasonCodes, totalHeaderReasonSelected} from "../util";
import _ from 'lodash'

const SameAsHeader = ({
  checkboxValue,
  handleCheckBoxChange,
  headerPartyType,
  label,
  disabled
}) => {
  if (headerPartyType === 'SELLER') return null
  return (
    <Form.Group>
      <CustomCheckBox
        label={label}
        value={checkboxValue}
        update={handleCheckBoxChange}
        disabled={disabled}
      />
    </Form.Group>
  )
}

class BondInfoFormTwo extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      midshownIndex: 0,
      showAllMids: false,
      showAddManfacc: false,
      newManfacIdz: "",
      midList_bv: [],
  }
  }
  enableDisableFrom = (enableForm) => {
    this.setState({
      "enableForm": enableForm
    })
  }

  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
    
  }

  render() {
    let {
      // importerValues,
      // updateActorFeild,
      // updateActorAddress,
      // updateHeaderPartyFeild,
      // updateHeaderPartyAddress,
      // saveHeaderParties,
      // saveHeaderPartiesByHeaderId,
      // updateHeaderParty,
      // saveImporter,
      // expandAll,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      // saveConsignee,
      // headerParties,
      isDisabled,
      //removeHeaderItemParty,
      // BOND INFO
      // addHeaderItemParty,

      // updateField,
      bondInfoValues,
      updateBondInfoField,
      updateAdditionalBondInfoField,
      saveHeaderReason,
      fieldValidation
    } = this.props
    let fieldValidationCopy= fieldValidation || {validObjects_bl:{}};

    let pscWarningAlertShow = this.selectedReasons.length<=0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')

    let formDisabled = this.props.formDisabled;
    if(this.state.enableForm === true){
      formDisabled = false;
    }
    //let manufacturerParties = headerParties.filter((a)=>a.headerPartyType.indexOf("MANUFACTURER")==0);

    return (<>
        {(get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) && (
          <PscHeaderReason
            {...this.props}
            pscState={get(this.props, "pscState.value.state")}
            totalHeaderReasonSelected={totalHeaderReasonSelected(
              this.props.pscData
            )}
            selectedOptions={this.selectedReasons}
            saveHeaderReason={saveHeaderReason}
            enableDisableFrom={this.enableDisableFrom}
          />
        )}
        
        <Form title={pscWarningAlertShow?"Must select a PSC reason before you can edit":""}>
        {/* BOND INFO */}
          <Grid className='no-gutters noBorderRadius'>



            {bondInfoValues.bondWaiver && (
              <Grid.Row className='blk1'>
                <Grid.Column width={16} className='secondCol'>
                  <DropDown
                    label='Bond Waiver Reason Code'
                    className='field-bg dropdown100'
                    width='16'
                    text={bondInfoValues.bondWaiverReasonCode}
                    data={['Code A', 'Code B']}
                    onChange={(value) => {
                      updateBondInfoField('bondWaiverReasonCode', value)
                      saveBondInfo('bondWaiverReasonCode', value)
                    }}
                    disabled={this.state.enableForm === true ? false : isDisabled("bondWaiverReasonCode")}
                    isLabel={true}
                  />
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column width={'8'} className='port-field no-field-margin'>
                <InputField
                  isLabel={false}
                  id='surety-number'
                  type='text'
                  label='SURETY NUMBER'
                  className='field-bg'
                  labelClassName='city'
                  value={bondInfoValues.suretyNumber}
                  disabled={this.state.enableForm === true ? false : isDisabled("suretyNumber")}
                  onChange={value => updateBondInfoField('suretyNumber', value)}
                  onBlur={value => {
                    saveBondInfo('suretyNumber', value)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  maxlength={3}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                  clearInput={true}
                  errors={
                    fieldValidationCopy.validObjects_bl[`BondValidationTabqwqr${"suretyNumber"}`]
                  }
                />
              </Grid.Column>
              <Grid.Column width={'8'} className='thirdCol no-field-margin'>
                <DropDown
                  id="BONDTYPEIDTHING"
                  label='BOND TYPE'
                  className='field-bg dropdown100 noLeftBorders'
                  columnClassName='bond-type'
                  isLabel={true}
                  text={bondInfoValues.bondType}
                  data={['CONTINUOUS', 'SINGLE_TRANSACTION']}
                  onChange={(value) => {
                    updateBondInfoField('bondType', value)
                    saveBondInfo('bondType', value)
                  }}
                  disabled={this.state.enableForm === true ? false : isDisabled("bondType")}
                  errors={
                    fieldValidationCopy.validObjects_bl[`BondValidationTabqwqr${"bondType"}`]
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='8' className='port-field no-field-margin'>
                <InputField
                  isLabel={false}
                  labelClassName='city'
                  id='bond-value'
                  type='text'
                  width='16'
                  label='BOND VALUE'
                  placeholder='Bond Value'
                  className='field-bg noTopBorders'
                  value={bondInfoValues.bondValue}
                  onChange={value => updateBondInfoField('bondValue', value)}
                  onBlur={value => {
                    saveBondInfo('bondValue', value)
                  }}
                  disabled={this.state.enableForm === true ? false : isDisabled("bondValue")}
                  clearInput={true}
                  // errors={
                  //   fieldValidationCopy.validObjects_bl[`BondValidationTabqwqr${"bondValue"}`]
                  // }
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <React.Fragment>
            <Grid width='equal'>
              {bondInfoValues.additionalBonds.map((bond, index) => (
                <Grid.Row
                  className='blk2 blkCom additional-bond'
                  width='16 '
                  key={index+" aggga"}
                >
                  <Grid.Column className='left'>
                    <Checkbox
                      disabled={Boolean(formDisabled)}
                      className='rounded'
                      label=''
                    />
                    <i
                      className='trash alternate outline icon'
                      //onClick={() => { removeAdditionalBond(index) }}
                    />
                  </Grid.Column>
                  <Grid.Row className='right'>
                    <Grid className='blk2-0'>
                      <InputField
                        isLabel={false}
                        id='single-number'
                        type='text'
                        label='SINGLE TRANSACTION BOND PRODUCER ACCOUNT NUMBER'
                        labelClassName='bond'
                        placeholder='SINGLE TRANSACTION BOND PRODUCER ACCOUNT NUMBER'
                        className='field-bg'
                        width='16'
                        input={{}}
                        onChange={value => {
                          updateAdditionalBondInfoField(
                            index,
                            'singleTransactionBondProducerAccountNumber',
                            value
                          )
                        }}
                        value={bond.singleTransactionBondProducerAccountNumber}
                        disabled={this.state.enableForm === true ? false : isDisabled("singleTransactionBondProducerAccountNumber")}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid>
                    <Grid className='blk2-1'>
                      <Grid.Row>
                        <Grid.Column>
                          <InputField
                            isLabel={false}
                            id={'surety-number' + index}
                            type='text'
                            label='SURETY NUMBER'
                            labelClassName='bond'
                            placeholder='SURETY NUMBER'
                            width='8'
                            className='field-bg'
                            input={{}}
                            value={bond.suretyNumber}
                            onChange={value => {
                              updateAdditionalBondInfoField(
                                index,
                                'suretyNumber',
                                value
                              )
                            }}
                            disabled={this.state.enableForm === true ? false : isDisabled("suretyNumber")}
                            newValue={newValue}
                            fieldName={fieldName}
                            setINPUTID={setINPUTID}
                            penClicked={penClicked}
                            shipmentId={shipmentId}
                            rbCounterID={rbCounterID}
                            clearInput={true}
                          />
                        </Grid.Column>
                        <Grid.Column>
                          <DropDown
                            label='BOND TYPE'
                            className='field-bg dropdown100'
                            labelClass='text-none'
                            width='8'
                            isLabel={true}
                            text={bond.bondType}
                            data={['CONTINUOUS', 'SINGLE_TRANSACTION']}
                            input={{}}
                            onChange={value => {
                              updateAdditionalBondInfoField(
                                index,
                                'bondType',
                                value
                              )
                            }}
                            disabled={this.state.enableForm === true ? false : isDisabled("bondType")}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <Grid className='blk2-1'>
                      <InputField
                        isLabel={false}
                        id={'bond-value' + index}
                        type='text'
                        width='16'
                        label='Bond Value'
                        labelClassName='bond'
                        placeholder='Bond Value'
                        className='field-bg col1'
                        input={{}}
                        value={bond.bondValue}
                        onChange={value => {
                          updateAdditionalBondInfoField(index, 'bondValue', value)
                        }}
                        disabled={this.state.enableForm === true ? false : isDisabled("bondValue")}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                    </Grid>
                  </Grid.Row>
                </Grid.Row>
              ))}
            </Grid>
          </React.Fragment>
        </Form>{/*END BONDINFO! */}
      </>
    )
  }
}

const mapStateToProps = (state, props) => ({
  bondInfoValues: state.BondInfo,
  importerValues: state.Importer,
  headerParties: state.Importer.headerParties,
  USStatesList: state.DropDownValues.USStatesList,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  rbCounterID: state.FormValues.rbCounterID,
  shipmentId: state.FormValues.shipmentId,
  formDisabled: state.FormValues.formDisabled,
  expandAll: state.FormValues.expandAll,
  tabName: "bondInformationTwo",
  pscData: state.PSC,
  fieldValidation: state.FieldValidation,
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondInfoFormTwo)